import {
  Grid, Card,
} from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ComponentTextInput from '../../../../../Common/ComponentTextinput/ComponentTextInput';
import './StyleMainTab.scss';
import { AnalystForm, SecondaryBasedFormInfo } from '../../utils/types';
import { LocalizationContext } from '../../../../../Common/Localization/LocalizationProvider';
import ComponentSelectInput from '../../../../../Common/ComponentSelectInput';
import { RootState } from '../../../../../redux/rootState';
import { analystSecondaryBasePinCodeDetailsStart, removeAnalystSecondaryBasePinCodeDetails } from '../../redux/AddAnalystSlice';
import { ANALYST_SECONDARY_BASE_INFO_KEY } from '../../utils/constants';
import { RHFAutocompleteField } from '../../../../../Common/ComponentAutoSelect';
import RequiredFiled from '../../../../../utils/RequiredField';

export default function SecondaryBasedForm({
  control, errors, setValue, watch,
}:SecondaryBasedFormInfo): JSX.Element {
  const { translations } = useContext(LocalizationContext);
  const { countries, citySuggestions } = useSelector((state: RootState) => state.masterDataReducer);
  const { isSecondaryBasePinError, analystSecondaryBasePinCodeDetails } = useSelector((state: RootState) => state.AddAnalystSliceReducer);
  const companyZip = watch(AnalystForm.sbZip);
  const countryName = watch(AnalystForm.sbCountry);
  const dispatch = useDispatch();

  useEffect(() => {
    if (companyZip && companyZip?.length >= 5 && countryName) {
      setValue(AnalystForm.sbState, '');
      const queryPayload = {
        pinCode: companyZip,
        countryCode: countryName,
        key: ANALYST_SECONDARY_BASE_INFO_KEY,
      };
      dispatch(analystSecondaryBasePinCodeDetailsStart(queryPayload));
    } else if (companyZip?.length < 5) {
      dispatch(removeAnalystSecondaryBasePinCodeDetails());
      setValue(AnalystForm.sbState, '');
    }
  }, [companyZip, countryName]);

  useEffect(() => {
    if (analystSecondaryBasePinCodeDetails?.City) {
      setValue(AnalystForm.sbState, analystSecondaryBasePinCodeDetails.StateName);
    }
  }, [analystSecondaryBasePinCodeDetails]);

  useEffect(() => {
    dispatch(removeAnalystSecondaryBasePinCodeDetails());
  }, []);

  // const otherCity = {
  //   Value: 'Other',
  //   Text: 'Other',
  // };

  const city = watch(AnalystForm.sbCity);

  const renderCityInput = () => {
    if (city === 'Other') {
      return true;
    }
    return false;
  };

  return (
    <Card>
      <div className="customerInfo_container">
        <div className="customerInfo">
          Secondary Base
        </div>
      </div>
      <div className="customerInfo_main_container">
        <Grid container spacing={2}>
          <Grid item md={3} sm={6} xs={12}>
            <div className="div_label_text">
              <label className="label_Style_Customer">
                {translations?.country}
              </label>
              <ComponentSelectInput
                name={AnalystForm.sbCountry}
                required
                errors={errors}
                control={control}
                handleChange={() => { setValue(AnalystForm.sbZip, ''); setValue(AnalystForm.sbCity, ''); }}
                size="small"
                entries={countries}
              />
            </div>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <div className="div_label_text">
              <label className="label_Style_Customer">
                {translations?.zip}
                <RequiredFiled />
              </label>
              <ComponentTextInput
                control={control}
                required
                errors={errors}
                regEx={/^[0-9]+$/}
                inputProps={{ maxLength: 10 }}
                name={AnalystForm.sbZip}
                id={AnalystForm.sbZip}
                size="small"
                handleChange={() => { setValue(AnalystForm.sbCity, ''); }}
              />
            </div>
            {isSecondaryBasePinError ? (<span className="errorMessage">Invalid zip code</span>) : ''}
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <div className="div_label_text">
              <label className="label_Style_Customer">
                {translations?.state}
              </label>
              <ComponentTextInput
                control={control}
                required
                errors={errors}
                isDisable
                name={AnalystForm.sbState}
                id={AnalystForm.sbState}
                size="small"
              />
            </div>
          </Grid>

          <Grid item md={3} sm={6} xs={12}>
            <div className="div_label_text">
              <label className="label_Style_Customer">
                {translations?.city}
                <RequiredFiled />
              </label>
              {renderCityInput() ? (
                <RHFAutocompleteField
                  options={citySuggestions || []}
                  control={control}
                  name={AnalystForm.otherSBCity}
                />
              )
                : (
                  <ComponentSelectInput
                    name={AnalystForm.sbCity}
                    control={control}
                    errors={errors}
                    defaultValue="kfjdklsfjlksd"
                    size="small"
                    entries={analystSecondaryBasePinCodeDetails?.City ? [...analystSecondaryBasePinCodeDetails.City] : []}
                  />
                )}
            </div>
          </Grid>
        </Grid>
      </div>
    </Card>
  );
}
